import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import hor_dropicon from '../assets/images/drop_horz.svg';
import dollaricon from '../assets/images/Dollar.svg';
import tip_icon from '../assets/images/tip_icon.svg';
import heart_icon from '../assets/images/heart_icon.svg';
import comment_icon from '../assets/images/comment_icon.svg';
import bookmark_icon from '../assets/images/bookmark_icon.svg';
import UserCardBlockedUsers from '../components/UserCardBlockedUsers';
import CollectionMenu from '../components/CollectionMenu'; 
import FollowingAllPost from '../components/FollowingAllPost';
import BookmarkAllPost from '../components/BookmarkAllPost';
import BookmarkPhotosPost from '../components/BookmarkPhotosPost';
import BookmarkVideosPost from '../components/BookmarkVideosPost';
import BookmarkAudioPost from '../components/BookmarkAudioPost';
import BookmarkOthersPost from '../components/BookmarkOthersPost';
import BookmarkLockedPost from '../components/BookmarkLockedPost';
import FollowingPhotosPost from '../components/FollowingPhotosPost';
import FollowingVideosPost from '../components/FollowingVideosPost';
import FollowingAudioPost from '../components/FollowingAudioPost';
import FollowingOthersPost from '../components/FollowingOthersPost';
import FollowingLockedPost from '../components/FollowingLockedPost';
import Bookmarks from '../components/Bookmarks';
import config from '../config/config';
import PropTypes from 'prop-types'; 

const Blocked = () => {
  const [userData, setUserData] = useState({ email: '', user_name: '' });
  const [newEmail, setNewEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [userLists, setUserLists] = useState([]);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [usersexpired, setExpiredUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalCountall, setTotalAllCount] = useState(0);
  const [totalCountactive, setTotalActiveCount] = useState(0);
  const [totalCountexpired, setTotalExpiredCount] = useState(0);
  const [fanusers, setFanUsers] = useState([]);
  const [totalFanCount, setTotalFanCount] = useState(0);
  const [isSearchVisible, setSearchVisible] = useState(false);
  const [showCreateListModal, setShowCreateListModal] = useState(false);
  const [showModal, setShowModal] = useState(false); 
  const [listName, setListName] = useState('');
  const [apiResponseMessage, setApiResponseMessage] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState(''); // 'success' or 'error'
  const [sortOption, setSortOption] = useState('recentlist');
  const [userIds, setUserIds] = useState([]);
  const [activeTab, setActiveTab] = useState('userLists');
  const [usersactive, setActiveUsers] = useState([]);
  const [restrictedUsers, setRestrictedUsers] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState('recent_users');
  const [walletBalance, setWalletBalance] = useState(0);  

  useEffect(() => {
    // Retrieve token from local storage
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    // Fetch current user details
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const user = response.data.data.user;
        setUserData(user);
        setNewEmail(user.email);
        setWalletBalance(user.wallet_balance); 
      } catch (error) {
        console.error('Error fetching user details', error);
      }
    };

    fetchUserDetails();
  }, [navigate]);

const token = localStorage.getItem('token');

const userIdsString = userIds.join(',');


useEffect(() => {
  axios.get(`${config.baseURL}/get-blocked-user`, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  })
  .then(response => {
    if (response.data.success) {
      const { users } = response.data;
      const count = users.length;

      // Update state with the blocked users data
      setRestrictedUsers(users); // Rename `setRestrictedUsers` to `setBlockedUsers` if it makes more sense
      setTotalCount(count);

      // Extract block_ids dynamically from users
      const ids = users.map(user => user.block_id);
      setUserIds(ids);
    }
  })
  .catch(error => {
    console.error('Error fetching blocked users:', error);
  });
}, [token]);



  const toggleSearch = () => {
    setSearchVisible(!isSearchVisible);
  };

  const closeSearch = () => {
    setSearchVisible(false);
  };

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const handleCreateListClick = () => {
    setShowCreateListModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab); // Update the active tab
  };


  // Function to handle the form submission
  const handleCreateListSubmit = async (e) => {
    e.preventDefault();
    try {
      if (listName.trim() === '') {
        setToastType('error');
        setToastMessage('List name cannot be empty');
        return;
      }
      if (listName.length > 64) {
        setToastType('error');
        setToastMessage('List name cannot exceed 64 characters');
        return;
      }

      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseURL}/create-user-list`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({ title: listName }), // Use 'title' instead of 'list_name'
      });

      const data = await response.json();
      if (data.success) {
        setToastType('success');
        setToastMessage('List created successfully!');
        setListName(''); // Clear list name
        setWordCount(0); // Reset word count
        setShowModal(false);
      } else {
        setToastType('error');
        setToastMessage('Failed to create list');
      }
    } catch (error) {
      setToastType('error');
      setToastMessage('Error creating list');
    }

    // Auto-hide the toast message after 3 seconds
    setTimeout(() => {
      setToastMessage('');
      setToastType('');
    }, 3000);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value); 
  };

  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value); // Set selectedFilter here, not sortOption
  };

  const handleFilterChangeUsers = (event) => {
    setSelectedFilter(event.target.value);
  };

  const handleFilterChangeList = (event) => {
      setSortOption(event.target.value);
  };

  const filteredUsers = (userList = []) => {
    if (!Array.isArray(userList)) {
      return []; // Return an empty array if userList is not valid
    }

    // Switch based on selectedFilter
    switch (selectedFilter) {
      case 'recent_users':
        return [...userList].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sort by creation date
      case 'subscription':
        return userList.filter(user => user.subs_mode === 'paid'); // Filter paid subscriptions
      case 'name_ascending':
        return [...userList].sort((a, b) => (a.name || '').localeCompare(b.name || '')); // Sort ascending by name
      case 'name_descending':
        return [...userList].sort((a, b) => (b.name || '').localeCompare(a.name || '')); // Sort descending by name
      default:
        return userList; // Return the original list if no filter is selected
    }
  };

  const handleButtonClick = () => {
    navigate('/fans'); 
  };

  useEffect(() => {
    document.title = "Blocked - PatreonPass";
  }, []);

  return (
    <div>

      {/* Toast Message */}
      {toastMessage && (
        <div className={`toast-message ${toastType}`}>
          {toastMessage}
        </div>
      )}

      <div className="main_patreonpass_wrapper collection_page_wrap">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings collection_page" id="content">                

              <div className="chat_main_content">
                  <div className="feed_wrapper">
                    <div className="page_title_with_dropdown notification_page">
                      <div className="page_heading">
                        <button className="profile_back_btn">
                          <svg
                            width={54}
                            height={54}
                            viewBox="0 0 54 54"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032"
                              stroke="#222"
                              strokeWidth={6}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                        <h1>Collections </h1>
                      </div>
                      <div className="create_post_btn">
                          <button
                            className="create_post_btn_area verify_btn search_btn_chat"
                            id="searchButton"
                            onClick={toggleSearch}
                          >
                            <svg
                              className="heading_search_icon"
                              width={38}
                              height={38}
                              viewBox="0 0 38 38"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                                stroke="#242529"
                                strokeWidth="3.88235"
                              />
                              <path
                                d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                                fill="#242529"
                              />
                            </svg>
                          </button>

                           <Link onClick={handleCreateListClick} className="create_post_btn_area verify_btn search_btn_chat chat_start">
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 27.5H49" stroke="black" stroke-width="7.41379" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M27.5 49V6" stroke="black" stroke-width="7.41379" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </Link>  

                        </div>
                        {isSearchVisible && (
                          <div id="searchContainer" className="collection_search">
                            <button
                              id="closeButton"
                              className="create_post_btn_area verify_btn search_btn_chat close_btn_search_after"
                              onClick={closeSearch}
                            >
                              <svg
                                width={54}
                                height={54}
                                viewBox="0 0 54 54"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 49L49 5"
                                  stroke="#8A96A3"
                                  strokeWidth="7.52867"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M49 49L5 5"
                                  stroke="#8A96A3"
                                  strokeWidth="7.52867"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                            <input
                              type="text"
                              id="searchInput"
                              placeholder="Search"
                              value={searchQuery}
                              onChange={handleSearchChange}
                            />
                            <button>
                              <svg
                                className="heading_search_icon"
                                width={38}
                                height={38}
                                viewBox="0 0 38 38"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                                  stroke="#00aff0"
                                  strokeWidth="3.88235"
                                />
                                <path
                                  d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                                  fill="#00aff0"
                                />
                              </svg>
                            </button>
                          </div>
                        )}
                    </div>
                    <div className="chat_message_block">
                      <div className="post_media_block">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                          <li className="nav-item" role="presentation">
                             <button
                              className={`nav-link ${activeTab === 'userLists' ? 'active' : ''}`}
                              id="posts-tab"
                              onClick={() => handleTabChange('userLists')}
                              type="button"
                              role="tab"
                              aria-controls="posts"
                              aria-selected={activeTab === 'userLists'}
                            >
                              User Lists
                            </button>
                          </li>
                          <li className="nav-item" role="presentation"> 
                            <button
                              className={`nav-link ${activeTab === 'bookmarks' ? 'active' : ''}`}
                              id="media-tab"
                              onClick={() => handleTabChange('bookmarks')}
                              type="button"
                              role="tab"
                              aria-controls="media"
                              aria-selected={activeTab === 'bookmarks'}
                            >
                              Bookmarks
                            </button>
                          </li>
                        </ul>
                        {/* Tab Content */}
                        <div className="tab-content" id="myTabContent">
                          <div
                              className={`tab-pane fade ${activeTab === 'userLists' ? 'show active' : ''}`}
                              id="posts"
                              role="tabpanel"
                              aria-labelledby="posts-tab"
                            >
                          <div className="post_top_section_head collection_tabs_content">
                              <div className="title_post_head">CUSTOM ORDER</div>
                              <div className="title_post_head_shorting">
                                 <div className="shorting_icons my_profile_menu">
                                    <a
                                      href="#"
                                      className="shorting_lists"
                                      id="productsDropdown"
                                      role="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <svg
                                        width={54}
                                        height={54}
                                        viewBox="0 0 54 54"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M4 44H15.3333"
                                          stroke="#8A96A3"
                                          strokeWidth="7.08333"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M4 27H32.3333"
                                          stroke="#8A96A3"
                                          strokeWidth="7.08333"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M4 10H49.3333"
                                          stroke="#8A96A3"
                                          strokeWidth="7.08333"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </a>
                                    <ul className="dropdown-menu" aria-labelledby="productsDropdown">
                                        <li className="dropdown">
                                          <input
                                            type="radio"
                                            id="recentlist"
                                            name="filter"
                                            value="recentlist"
                                            checked={sortOption === 'recentlist'}
                                            onChange={handleFilterChangeList}
                                          />
                                          <label htmlFor="recentlist" className="dropdown-item">Recent</label>
                                        </li>
                                        <li className="dropdown">
                                          <input
                                            type="radio"
                                            id="name"
                                            name="filter"
                                            value="name"
                                            checked={sortOption === 'name'}
                                            onChange={handleFilterChangeList}
                                          />
                                          <label htmlFor="name" className="dropdown-item">Name</label>
                                        </li>
                                        <li className="dropdown">
                                          <input
                                            type="radio"
                                            id="ascendinglist"
                                            name="filter"
                                            value="ascendinglist"
                                            checked={sortOption === 'ascendinglist'}
                                            onChange={handleFilterChangeList}
                                          />
                                          <label htmlFor="ascendinglist" className="dropdown-item">Ascending</label>
                                        </li>
                                        <li className="dropdown">
                                          <input
                                            type="radio"
                                            id="descendinglist"
                                            name="filter"
                                            value="descendinglist"
                                            checked={sortOption === 'descendinglist'}
                                            onChange={handleFilterChangeList}
                                          />
                                          <label htmlFor="descendinglist" className="dropdown-item">Descending</label>
                                        </li>
                                      </ul>
                                  </div>
                              </div>
                            </div>
                            <div className="edit_settings_menu_list collection_page_menus_left"> 
                              <CollectionMenu config={config} searchQuery={searchQuery} sortOption={sortOption} />
                            </div>
                          </div>
                           <div
                              className={`tab-pane fade ${activeTab === 'bookmarks' ? 'show active' : ''}`}
                              id="media"
                              role="tabpanel"
                              aria-labelledby="media-tab"
                            >
                            <Bookmarks sortOption={sortOption} handleFilterChange={handleFilterChange} />

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              {activeTab === 'userLists' && (  
              <div className="right_main_content chat_messages_list collection_page_only">
                  <div className="page_title_with_dropdown collection_page_right_heading">
                    <div className="page_heading">
                      <div className="chat_header">
                        <h1> Blocked</h1>
                      </div>
                    </div>
                    <div className="collection_right_tabs post_media_block">
                      <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link active"
                            id="posts-tab-users"
                            data-bs-toggle="tab"
                            data-bs-target="#users-tab-content"
                            type="button"
                            role="tab"
                            aria-controls="posts"
                            aria-selected="true"
                          >
                            Users 
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link"
                            id="posts-tab-posts"
                            data-bs-toggle="tab"
                            data-bs-target="#posts-tab-content"
                            type="button"
                            role="tab"
                            aria-controls="media"
                            aria-selected="false"
                            tabIndex={-1} onClick={handleButtonClick}
                          >
                            Posts
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="tab_content_right_collections">
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active"
                        id="users-tab-content"
                        role="tabpanel"
                        aria-labelledby="posts-tab-users"
                      >
                        <div className="post_top_section_head collection_tabs_content">
                          <div className="title_post_head">RECENT</div>
                          <div className="title_post_head_shorting">
                            <div className="shorting_icons my_profile_menu">                            
                              <a
                                href="#"
                                className="shorting_lists"
                                id="productsDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <svg
                                  width={54}
                                  height={54}
                                  viewBox="0 0 54 54"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4 44H15.3333"
                                    stroke="#8A96A3"
                                    strokeWidth="7.08333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M4 27H32.3333"
                                    stroke="#8A96A3"
                                    strokeWidth="7.08333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M4 10H49.3333"
                                    stroke="#8A96A3"
                                    strokeWidth="7.08333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </a>
                              <ul className="dropdown-menu" aria-labelledby="productsDropdown">
                                <li className="dropdown">
                                  <input
                                    type="radio"
                                    id="available"
                                    name="status"
                                    value="recent_users"
                                    checked={selectedFilter === 'recent_users'}
                                    onChange={handleFilterChange}
                                  />
                                  <label htmlFor="available" className="dropdown-item">Recent</label>
                                </li>
                                <li className="dropdown">
                                  <input
                                    type="radio"
                                    id="subscription"
                                    name="status"
                                    value="subscription"
                                    checked={selectedFilter === 'subscription'}
                                    onChange={handleFilterChange}
                                  />
                                  <label htmlFor="subscription" className="dropdown-item">Subscription</label>
                                </li>
                                <hr />
                                 <li className="dropdown">
                                  <input
                                    type="radio"
                                    id="ascending"
                                    name="status"
                                    value="name_ascending"
                                    checked={selectedFilter === 'name_ascending'}
                                    onChange={handleFilterChange}
                                  />
                                  <label htmlFor="ascending" className="dropdown-item">Ascending</label>
                                </li>
                                <li className="dropdown">
                                  <input
                                    type="radio"
                                    id="descending"
                                    name="status"
                                    value="name_descending"
                                    checked={selectedFilter === 'name_descending'}
                                    onChange={handleFilterChange}
                                  />
                                  <label htmlFor="descending" className="dropdown-item">Descending</label>
                                </li>
                              </ul>

                            </div>
                          </div>
                        </div>
                        <div className="user_list_following">
                          <div className="category_pills">
                            <div className="profile_cards_user"> 
                                <div className="row collection_with_cards">  
                                  {filteredUsers(restrictedUsers).length > 0 ? (
                                    filteredUsers(restrictedUsers).map(blockedUser => (
                                      <UserCardBlockedUsers 
                                        key={blockedUser.block_id} 
                                        user={blockedUser.user}
                                        walletBalance={walletBalance} 
                                      />
                                    ))
                                  ) : (
                                    <p className="no_list">No users found</p>
                                  )}
                                </div>
                              </div>

                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="posts-tab-content"
                        role="tabpanel"
                        aria-labelledby="posts-tab-posts"
                      >
                        <div className="user_posts_collections">
                                                    
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'bookmarks' && (
              <div className="right_main_content chat_messages_list bookmark_page_only"> 
                  <div className="page_title_with_dropdown collection_page_right_heading">
                    <div className="page_heading">
                      <div className="chat_header">
                        <h1> ALL BOOKMARKS</h1>
                      </div>
                    </div>
                  </div>
                  
                  <div className="user_posts_collections bookmarks_top_margin">                 

                        <div className="category_pills">
                            <div className="pill_tabs">
                              <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link active"
                                    id="pills-post-all-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-post-all"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-post-all"
                                    aria-selected="true"
                                  >
                                    All
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="pills-post-photos-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-post-photos"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-post-photos"
                                    aria-selected="false"
                                  >
                                    Photos
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="pills-post-videos-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-post-videos"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-post-videos"
                                    aria-selected="false"
                                  >
                                    Videos
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="pills-post-audio-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-post-audio"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-post-audio"
                                    aria-selected="false"
                                  >
                                    Audio
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="pills-post-others-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-post-others"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-post-others"
                                    aria-selected="false"
                                  >
                                    Other
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="pills-post-locked-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-post-locked"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-post-locked"
                                    aria-selected="false"
                                  >
                                    Locked
                                  </button>
                                </li>
                              </ul>
                            </div>
                            <div className="tab-content" id="pills-tabContent">
                              <div
                                className="tab-pane fade show active"
                                id="pills-post-all"
                                role="tabpanel"
                                aria-labelledby="pills-post-all-tab"
                              >
                                {/* Content for All */}

                                <BookmarkAllPost userIds={userIdsString} walletBalance={walletBalance} />
                              </div>
                              <div
                                className="tab-pane fade"
                                id="pills-post-photos"
                                role="tabpanel"
                                aria-labelledby="pills-post-photos-tab"
                              >
                                {/* Content for Photos */}
                                <BookmarkPhotosPost userIds={userIdsString} walletBalance={walletBalance} />
                              </div>
                              <div
                                className="tab-pane fade"
                                id="pills-post-videos"
                                role="tabpanel"
                                aria-labelledby="pills-post-videos-tab"
                              >
                                {/* Content for Videos */}
                                <BookmarkVideosPost userIds={userIdsString} walletBalance={walletBalance} />
                              </div>
                              <div
                                className="tab-pane fade"
                                id="pills-post-audio"
                                role="tabpanel"
                                aria-labelledby="pills-post-audio-tab"
                              >
                                {/* Content for Audio */}
                                <BookmarkAudioPost userIds={userIdsString} walletBalance={walletBalance} />                                
                              </div>
                              <div
                                className="tab-pane fade"
                                id="pills-post-others"
                                role="tabpanel"
                                aria-labelledby="pills-post-others-tab"
                              >
                                {/* Content for Other */}
                                <BookmarkOthersPost userIds={userIdsString} walletBalance={walletBalance} />                                   
                              </div>

                               <div
                                className="tab-pane fade"
                                id="pills-post-locked"
                                role="tabpanel"
                                aria-labelledby="pills-post-locked-tab"
                              >
                                {/* Content for Locked */}
                                <BookmarkLockedPost userIds={userIdsString} walletBalance={walletBalance} />                                   
                              </div>
                            </div>
                          </div>  
                         </div>
                    
                </div>  
              )}  

          </div>
        </div>
      </div>



    {/* Create New List Modal */}
      {showCreateListModal && (
        <>
          <div className="modal-overlay-dark" onClick={() => setShowCreateListModal(false)}></div>
          <div id="restoreAccessForm" className="modal restoreAccessModalAccess fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="createListModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="createListModalLabel">CREATE NEW LIST</h5>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleCreateListSubmit}>
                    <div className="position_relative">
                      <input
                        type="text"
                        className="form-control"
                        value={listName}
                        onChange={(e) => {
                          setListName(e.target.value);
                          setWordCount(e.target.value.length);
                        }}
                        maxLength="64"
                        placeholder=""
                      />
                      <label htmlFor="listname" className="placeholder-label">List Name</label>
                      <div className="word_count">{wordCount} / 64</div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-primary send_btn" onClick={() => setShowCreateListModal(false)}>Cancel</button>
                      <button type="submit" className="btn btn-primary send_btn">Save</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}


    </div>
  );
};

export default Blocked;
